import { FullScreenTakeOver } from 'ui/takeOver';
import { Button } from 'ui/button';
import { noop } from 'lodash';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { selectPresentState } from 'modules/queryBuilder/legacyQueryBuilder/selectors';
import { useCallback } from 'react';
import { StartNodeData } from 'modules/workflows/types';
import { ScheduledAdditionalCriteriaTakeOverBody } from './ScheduledAdditionalCriteriaTakeOverBody';

const StyledAboutButtons = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

const TAKEOVER_TITLE = 'Additional entry requirements';

type ScheduledJourneyAdditionalCriteriaTakeoverProps = {
  onChange?: (searchQuery: any) => void;
  onClose?: () => void;
  nodeData?: StartNodeData;
};

export const ScheduledJourneyAdditionalCriteriaTakeover = ({
  nodeData = undefined,
  onClose = noop,
  onChange = noop,
}: ScheduledJourneyAdditionalCriteriaTakeoverProps) => {
  const searchQuery = useSelector(selectPresentState);
  const getNodeDataForSaving = useCallback(() => {
    return {
      searchQuery,
      matchTriggeringEventFields: false,
    };
  }, [searchQuery]);

  const handleOnClose = () => {
    onClose();
  };

  const handleSubmit = () => {
    const nodeDataForSaving = getNodeDataForSaving();
    onChange(nodeDataForSaving);
    handleOnClose();
  };

  /**
   * The reason we are doing this is because FieldsMatchQueryBuilder is now used by both the scheduled journey
   * and yes/no split tiles. The start tile has a searchCombo definition in the backend whereas the yes/no split
   * has searchQuery. The code that parses the array of queries looks for searchQuery, and that's why we are assigning
   * searchQuery to the value of the searchCombo
   */
  const nodeDataWithSearchCombo = Object.assign({}, nodeData);
  if (!nodeDataWithSearchCombo.searchQuery && nodeDataWithSearchCombo.searchCombo) {
    nodeDataWithSearchCombo.searchQuery = nodeDataWithSearchCombo.searchCombo;
  }

  return (
    <FullScreenTakeOver
      onClose={handleOnClose}
      title={TAKEOVER_TITLE}
      Footer={
        <StyledAboutButtons>
          <Button onClick={handleSubmit}>Save</Button>
        </StyledAboutButtons>
      }
    >
      <ScheduledAdditionalCriteriaTakeOverBody nodeData={nodeDataWithSearchCombo} />
    </FullScreenTakeOver>
  );
};
